// extracted by mini-css-extract-plugin
module.exports = {"noteZero_image":"ZeroState_noteZero_image__axJQX","browserIcon":"ZeroState_browserIcon__1SXmE"};